import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    CircularProgress,
} from '@mui/material';
import apiClient from '../utils/apiClient';
import { setToken } from '../utils/auth';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Login = ({ onLogin }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setError('');
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!formData.email || !formData.password) {
    //         setError('Email and Password are required');
    //         return;
    //     }

    //     setLoading(true);
    //     setError('');

    //     try {
    //         const response = await axios.post(`${apiUrl}/employee/login`, {
    //             email: formData.email,
    //             password: formData.password,
    //         });

    //         const { token, status, message } = response.data;

    //         if (status && token) {
    //             sessionStorage.setItem('token', token);
    //             toast.success('Login successful!');
    //             onLogin(); 
    //         } else {
    //             setError(message || 'Invalid credentials');
    //         }
    //     } catch (err) {
    //         console.log(err, "err in login")
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
        setError('Email and Password are required');
        return;
    }

    setLoading(true);
    setError('');

    try {
        const response = await apiClient.post(`/employee/login`, {
            email: formData.email,
            password: formData.password,
        });

        const { token, status, message } = response.data;

        if (status && token) {
            setToken(token);
            toast.success('Login successful!');

            onLogin && onLogin(); // safe call
            navigate("/display-dashboard"); // ✅ IMPORTANT
        } else {
            setError(message || 'Invalid credentials');
        }
    } catch (err) {
        console.log(err, "err in login");
        setError("Login failed");
    } finally {
        setLoading(false);
    }
};
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f4f6f8"
        >
            <Paper elevation={3} sx={{ p: 4, width: 350 }}>
                <Typography variant="h5" mb={3} textAlign="center">
                    Login
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={formData.email}
                        onChange={handleChange}
                        error={Boolean(error && !formData.email)}
                    />
                  <TextField
    label="Password"
    name="password"
    type={showPassword ? "text" : "password"}
    fullWidth
    size="small"
    margin="normal"
    value={formData.password}
    onChange={handleChange}
    error={Boolean(error && !formData.password)}
    InputProps={{
        endAdornment: (
            <InputAdornment position="end">
                <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </InputAdornment>
        ),
    }}
/>

                    {error && (
                        <Typography color="error" mt={1} fontSize="0.9rem">
                            {error}
                        </Typography>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Login'}
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default Login;
